import type { TrailPoint } from "./pathMemory";

export type StoredNight = {
  path: TrailPoint[];
  knots: number;
  endedAt: string;
};

export type SaveData = {
  version: 1;
  night: number;
  nights: StoredNight[];
};

const DATABASE_NAME = "underfoot";
const STORE_NAME = "save";
const KEY = "primary";

export function newSave(): SaveData {
  return { version: 1, night: 1, nights: [] };
}

function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE_NAME, 1);
    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        database.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function loadSave(): Promise<SaveData> {
  try {
    const database = await openDatabase();
    return await new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, "readonly");
      const request = transaction.objectStore(STORE_NAME).get(KEY);
      request.onsuccess = () => resolve((request.result as SaveData | undefined) ?? newSave());
      request.onerror = () => reject(request.error);
    });
  } catch {
    const legacy = localStorage.getItem("underfoot-save");
    return legacy ? (JSON.parse(legacy) as SaveData) : newSave();
  }
}

export async function persistSave(save: SaveData): Promise<void> {
  try {
    const database = await openDatabase();
    await new Promise<void>((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, "readwrite");
      transaction.objectStore(STORE_NAME).put(save, KEY);
      transaction.oncomplete = () => resolve();
      transaction.onerror = () => reject(transaction.error);
    });
  } catch {
    localStorage.setItem("underfoot-save", JSON.stringify(save));
  }
}
